import { Button } from '@mantine/core';
import { AiOutlineDelete } from 'react-icons/ai';
import { useState } from 'react';
import { Product } from '../../products/types';
import { deleteStripeProduct } from '../services/StripeProductService';

interface DeleteStripeProductButtonProps {
    product: Product;
    onProductDeleted?: () => void;
}

export const DeleteStripeProductButton = ({ product, onProductDeleted }: DeleteStripeProductButtonProps) => {
    const [loading, setLoading] = useState(false);

    const handleDelete = async () => {
        if (!product.billingProviderRecordId) return;
        
        setLoading(true);
        try {
            await deleteStripeProduct(product.billingProviderRecordId, product.id);
            if (onProductDeleted) {
                onProductDeleted();
            }
        } catch (error) {
            console.error('Failed to delete Stripe product:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Button
            leftSection={<AiOutlineDelete size={16} />}
            size="xs"
            variant="light"
            color="red"
            loading={loading}
            onClick={handleDelete}
        >
            Delete from Stripe
        </Button>
    );
};